import axios from "axios";
import API from "../constants/api";

export const login = (username, password) => {
  return axios.post(`${API}/users/post/admin/login`, {
    username,
    password
  });
};
